// LoadingIndicator
// ***********************************************************************************************************************
import * as React from "react";
import { t } from "i18next";

export interface ILoadingIndicatorProp {
    tooltip?: string;
    classes?: string;
}

export class LoadingIndicator extends React.Component<ILoadingIndicatorProp> {
    render() {
        const props = this.props;
        return (
            <img className={"loadingIndicator" + (props.classes ? " " + props.classes : "")} alt={t("common.loading")} title={props.tooltip ? props.tooltip : t("common.loading")} src={appConfig.ownRoot + "spinner-loader.gif"} />
        );
    }
}
